<template>
  <v-text-field :label="title" ref="textfield" :value="value" readonly class="service-credentials-textfield" @click="copyText()" box>
    <template v-slot:append>
      <v-scroll-x-transition>
        <div v-if="isCopied">
          <v-icon color="green">done</v-icon>
          <div style="padding-top: 6px; display: inline-block;">
            Copied!
          </div>
        </div>
      </v-scroll-x-transition>
    </template>
  </v-text-field>
</template>

<script>
  export default {
    props: {
      title: String,
      value: String,
    },
    data() {
      return {
        isCopied: false,
      }
    },
    methods: {
      copyText() {
        this.isCopied = true
        this.$refs.textfield.$el.querySelector('input').select()
        document.execCommand('copy')
        this.setCopiedFalse()
      },
      async setCopiedFalse() {
        setTimeout(function() { this.isCopied = false }.bind(this), 1500)
      },
    },
  }
</script>